$("document").ready(function () {
  const htmlGear =
      '<div class="search-loading" style="text-align: center"><img style="width: 33px;" src="//cdn.shopify.com/s/files/1/0423/5264/0158/t/3/assets/loading.gif?v=98483387235098988781649237607"></div>',
    htmlGearWhite =
      '<div class="search-loading" style="text-align: center"><img style="width: 33px;" src="//usa.duralite.net/cdn/shop/t/7/assets/loading-white.gif?v=79143557868823759471688466584"></div>';
  $(".search-button a").hide(),
    $(".search-button").append(htmlGear),
    $(".Herosearch").hide(),
    $(".Herosearch").after(htmlGear),
    $(".Alertbar .content-wrapper form").hide(),
    $(".Alertbar .content-wrapper form").after(htmlGearWhite),
    $("#searchbar form").hide(),
    $("#searchbar form").after(htmlGear),
    $(".store-button#shop-button").hide(),
    $(".gv-mmy-bar").hide(),
    $("form").attr("autocomplete", "off"),
    $("#bc-product-search").attr("aria-autocomplete", "none"),
    $(".Alertbar #bc-product-search1").attr("aria-autocomplete", "none"),
    $("#bc-product-search").attr("role", "presentation"),
    $(".Alertbar #bc-product-search1").attr("role", "presentation"),
    setTimeout(() => {
      if (
        ($("#bc-product-search").val(""),
        $(".Alertbar #bc-product-search1").val(""),
        $(".search-loading").remove(),
        $(".search-button a").show(),
        $(".Herosearch").show(),
        $(".Alertbar .content-wrapper form").show(),
        $(".Alertbar .content-wrapper form").show(),
        $(".Alertbar .content-wrapper #bc-product-search1").show(),
        $("#searchbar form").show(),
        $(".store-button#shop-button").show(),
        $(".gv-mmy-bar").show(),
        $(".Alertbar .content-wrapper #f2remove").length > 0)
      ) {
        var html = $(".Alertbar .content-wrapper #f2remove").html();
        $(".Alertbar .content-wrapper #f2remove").remove(),
          $(".Alertbar #rm").html(html),
          $(".Alertbar #rm input").show(),
          $("#searchModal .snize-input-style").removeClass("snize-input-style");
      }
      waitUntilElementExistAndStartFunction(
        100,
        () => {
          $("#searchModal .snize-input-style").removeClass("snize-input-style"),
            $("#searchModal #bc-product-search1").attr("id", "bc-product-search"),
            $(".Alertbar .snize-input-style").removeClass("snize-input-style");
        },
        "#searchModal .snize-input-style",
        1e3
      );
    }, 2e3)
    ,
    addTooltip(),
    $(document).on("mouseover", ".imapsSprite-group[role='group']", function (event) {
      const childElements = $(this).find(".imapsMapObject-group");
      if (childElements.length > 0) {
        const ids = childElements
          .map(function () {
            return $(this).attr("id");
          })
          .get();
        ids.length > 0 && showCorrectToolTip(ids), console.log(ids);
      }
      childElements.each(function () {
        $(this).css("transition", "fill 0.5s ease").css("fill", "#ffcc3e");
      });
    }),
    $(document).on("mouseout", ".imapsSprite-group[role='group']", function () {
      const childElements = $(this).find(".imapsMapObject-group");
      $(".tooltip-map").css({ display: "none" }),
        childElements.each(function () {
          $(this).css("transition", "fill 0.5s ease").css("fill", "black");
        });
    });
});
const addTooltip = () => {
    var tooltips = document.querySelectorAll(".tooltip-map");
    window.onmousemove = function (e) {
      for (var x = e.clientX + 20 + "px", y = e.clientY + 20 + "px", i = 0; i < tooltips.length; i++)
        (tooltips[i].style.top = y), (tooltips[i].style.left = x);
    };
  },
  showCorrectToolTip = (arrayIds) => {
    arrayIds.includes("id-443") &&
      $("#tooltip-map-1").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-430") &&
        $("#tooltip-map-2").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-397") &&
        $("#tooltip-map-3").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-388") &&
        $("#tooltip-map-4").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-269") &&
        $("#tooltip-map-5").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-330") &&
        $("#tooltip-map-6").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" }),
      arrayIds.includes("id-359") &&
        $("#tooltip-map-7").css({ display: "block", position: "fixed", overflow: "hidden", "z-index": "9999" });
  };
function waitUntilElementExistAndStartFunction(checkTimer, functionInfo, htmlElement, maxRepeat) {
  var counter = 0,
    checkExist = setInterval(function () {
      $(htmlElement).length
        ? (clearInterval(checkExist), functionInfo())
        : (counter++, counter === maxRepeat && clearInterval(checkExist));
    }, checkTimer);
}
//# sourceMappingURL=/s/files/1/0419/7416/9759/t/27/assets/GlobalCustom.js.map?v=1712161948
